import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

import * as at from "../actions/types";

const initialState = {
  loading: false,
  data: [],
};

const myGroups = (state = initialState, action) => {
  switch (action.type) {
    case at.CLEAR_MY_GROUPS:
      return { ...state, data: [] };
    case errorAction(types.GET_MY_GROUPS):
      return { ...state, loading: false };
    case successAction(types.GET_MY_GROUPS):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.GET_MY_GROUPS):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default myGroups;
